import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  DEFAULT_BORDER,
  FIELD_SPACE,
  FONT_WEIGHT_MEDIUM,
  IMAGE_BORDER_RADIUS,
  PREVIEW_HEIGHT,
  PREVIEW_HEIGHT_MD,
  PREVIEW_WIDTH,
  PREVIEW_WIDTH_MD,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {cloneDeep} from "lodash";
import TextField from "@material-ui/core/TextField";
import {IMAGE_MAX_WIDTH_HEIGHT} from "../commons/FilePicker";
import FileHelper from "../../utils/FileHelper";
import DateTimeHelper from "../../utils/DateTimeHelper";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  ACCEPTED_VIDEO_MIMES,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO
} from "../commons/SingleFilePicker";
import constants from "../../constants";
import ValueHelper, {getInitialFiles, textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import {Button} from "@material-ui/core";
import ApiHelper from "../../utils/ApiHelper";
import {
  ColorButtonSelected,
  ColorButtonSelectedHover,
  ColorFieldBorder,
  ColorFieldBorderHover,
  ColorPreviewBorder,
  ColorSeparator,
  ColorSubTitle,
  ColorTheme,
  ColorWhite
} from "src/styles/Colors";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {GetViewForItem} from "src/js/components/activity/FunLists";
import TextView from "src/js/components/commons/TextView";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {ImageIcon, SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";

const useStyles = (theme) => ({
  campaignImagePickerPlaceholder: {
    width: 88,
    height: 50,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewItem: {
    borderRadius: BORDER_RADIUS,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: ColorWhite,
  },
  previewItemImage: {
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
    width: '100%',
    aspectRatio: 16/9
  },
  previewBusinessImage: {
    borderRadius: IMAGE_BORDER_RADIUS,
    width: 44,
    height: 44,
    border: DEFAULT_BORDER
  },
  previewView: {
    display: 'flex',
    flexDirection: 'column',
    width: PREVIEW_WIDTH,
    height: PREVIEW_HEIGHT,
    [theme.breakpoints.down('md')]: {
      width: PREVIEW_WIDTH_MD,
      height: PREVIEW_HEIGHT_MD,
    },
  },
  linkBg: {
    backgroundColor: ColorPreviewBorder, borderRadius: BORDER_RADIUS, width: 32, height: 32,
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    marginBottom: 6,
  },
  radioButtonLink: {
    display: 'flex',
    flex: 1,
    marginLeft: 0,
    marginRight: 0,
    padding: 12,
    borderRadius: BORDER_RADIUS,
    backgroundColor: ColorWhite,
    border: '1px solid '+ ColorFieldBorder,
    '&:hover': {
      backgroundColor: '#eeeeee',
      border: '1px solid '+ ColorFieldBorderHover,
    },
    maxWidth: Math.min(window.appWidth, 400),
    [theme.breakpoints.down('xs')]: {
      maxWidth: window.appWidth
    },
  },
  radioButtonLinkSelected: {
    display: 'flex',
    flex: 1,
    marginLeft: 0,
    marginRight: 0,
    padding: 12,
    borderRadius: BORDER_RADIUS,
    backgroundColor: ColorButtonSelected,
    border: '1px solid '+ ColorTheme,
    '&:hover': {
      backgroundColor: ColorButtonSelectedHover,
      border: '1px solid '+ ColorTheme,
    },
    maxWidth: Math.min(window.appWidth, 400),
    [theme.breakpoints.down('xs')]: {
      maxWidth: window.appWidth
    },
  }
});

const AUTO_RESTART_DAYS = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.autoRestartNone'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.autoRestartDaily'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.manage.autoRestart3Days'/>},
  {'id': 7, 'name': <FormattedMessage id='activity.manage.autoRestart7Days'/>},
  // {'id': 10, 'name': <FormattedMessage id='activity.manage.autoRestart10Days'/>},
];

class ManageActivityBasicInfo extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.minOfferValidity = 0;
    this.offerValidity = 0;
    if (activityData.activityConfigs) {
      this.minOfferValidity = activityData.activityConfigs.minOfferValidity;
      this.offerValidity = activityData.activityConfigs.offerValidity;
    }
    this.maxVideoDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxVideoDuration = activityData.mediaConfigs.maxVideoDuration;
    }

    const isReward = this.isReward();
    const imageUrl = activityData.imageUrl && activityData.imageUrl !== ApiHelper.getActivityDefaultImageUrl(activityData.type, activityData.subType, activityData.gameInfo) ? activityData.imageUrl : null;
    const mediaUrl = isReward ? activityData.videoUrl || imageUrl : imageUrl;
    const mediaFiles = isReward ? activityData.videoFiles || activityData.imageFiles : activityData.imageFiles;
    const mediaType = isReward ? activityData.videoUrl ? FILE_TYPE_VIDEO : FILE_TYPE_IMAGE : FILE_TYPE_IMAGE;
    const mediaTUrl = isReward ? activityData.videoTUrl : null;
    const isMediaDeleted = isReward ? activityData.isVideoDeleted || activityData.isImageDeleted : activityData.isImageDeleted;

    this.dateNow = new Date();
    this.dateMax = DateTimeHelper.getDateAfterYears(this.dateNow, 1);
    const resetGameDays = activityData.consumeLimitPerDay || 0;

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.manage.sectionCampaignBudget', expand: true, expandAlways: true, subLabelId: 'activity.manage.sectionHintAdBudget'},
        {id: 2, labelId: 'activity.manage.sectionResetDays', expand: resetGameDays && resetGameDays > 0, subLabelId: 'activity.manage.sectionHintAutoRestart'},
      ],
      reload: false,
      showValidationMsg: false,
      name: activityData.title,
      nameAr: activityData.titleAr || '',
      imageUrl: activityData.imageUrl,
      imageFiles: activityData.imageFiles,
      isImageDeleted: activityData.isImageDeleted,
      imageUrlAr: activityData.imageUrlAr,
      imageFilesAr: activityData.imageFilesAr,
      isImageDeletedAr: activityData.isImageDeletedAr,
      startAt: activityData.startAt instanceof Date ? activityData.startAt : DateTimeHelper.getDateFromDateString(activityData.startAt),
      endAt: activityData.endAt instanceof Date ? activityData.endAt : DateTimeHelper.getDateFromDateString(activityData.endAt),
      description: activityData.description || '',
      endInDay: activityData.endInDay,
      linkText: activityData.linkText || '',
      link: activityData.link || '',
      resetGameDays: resetGameDays,
      fee: activityData.fee,
      videoUrl: activityData.videoUrl,
      videoFiles: activityData.videoFiles,
      isVideoDeleted: activityData.isVideoDeleted,
      mediaUrl: mediaUrl,
      mediaFiles: mediaFiles,
      isMediaDeleted: isMediaDeleted,
      isLinkOnly: activityData.isLinkOnly ? '1' : '0',
      previewData: this.getPreviewData(this.props.previewData),
    };

    this.initialFiles = getInitialFiles(activityData.imageFiles, imageUrl, FILE_TYPE_IMAGE);
    this.initialMediaFiles = getInitialFiles(mediaFiles, mediaUrl, mediaType, mediaTUrl);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  highlightErrors = () => {
    this.getData();
  }

  onPreviewUpdated = (previewActivity) => {
    this.setState({previewData: this.getPreviewData(previewActivity), reload: !this.state.reload});
  }

  getPreviewData(previewActivity) {
    if (previewActivity) {
      const previewData = previewActivity.previewBasics;
      previewData.id = previewActivity.id;
      previewData.type = previewActivity.type;
      previewData.startAt = previewActivity.startAt;
      previewData.endAt = previewActivity.endAt;
      previewData.business = {
        name: previewActivity.previewCta1.title,
        imageUrl: previewActivity.previewCta1.imageUrl,
      };
      return previewData;
    }
    return null;
  }

  isReward() {
    const {activityData} = this.props;
    return activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.DISCOUNT
      || activityData.type === constants.activity.types.VOUCHER;
  }

  updateState(fields) {
    this.setState(fields, () => {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        this.props.onDataUpdated(this.getData(true));
        this.timeoutHandler = null;
      }, 400);
    });
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      name,
      nameAr,
      startAt,
      endAt,
      description,
      endInDay,
      linkText,
      link,
      fee,
      mediaUrl,
      mediaFiles,
      isMediaDeleted,
      isLinkOnly,
      resetGameDays
    } = this.state;

    if (!excludeError) {
      let loyaltyPointsCheckPassed = true;
      if (activityData.usageType === constants.activity.usageTypes.LOYALTY && (
        activityData.type === constants.activity.types.OFFER
        || activityData.type === constants.activity.types.VOUCHER
        || activityData.type === constants.activity.types.DISCOUNT
      )) {
        loyaltyPointsCheckPassed = fee && ValueHelper.getEnglishValue(fee) > 0
      }
      const endInDayApplicable = activityData.type === constants.activity.types.OFFER
        || activityData.type === constants.activity.types.VOUCHER
        || activityData.type === constants.activity.types.DISCOUNT;
      if (!name
        || (endInDayApplicable && (!endInDay || ValueHelper.getEnglishValue(endInDay) < this.minOfferValidity))
        || !startAt || (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow))
        // || !endAt || !DateTimeHelper.isDateAfter(endAt, startAt ? startAt : this.dateNow)
        || !loyaltyPointsCheckPassed
      ) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    let isImageDeleted = false;
    let isVideoDeleted = false;
    let imageUrl = activityData.imageUrl;
    let videoUrl = activityData.videoUrl;
    let imageFiles = null;
    let videoFiles = null;
    if (!mediaUrl) {
      videoUrl = null;
      imageUrl = null;
      isImageDeleted = true;
      isVideoDeleted = true;
    }
    if (mediaFiles && mediaFiles.length > 0) {
      if (mediaFiles[0].type === FILE_TYPE_VIDEO) {
        videoFiles = mediaFiles;
      } else {
        imageFiles = mediaFiles;
      }
    }

    const data = {
      title: name,
      titleAr: nameAr,
      startAt,
      endAt,
      imageUrl,
      imageFiles,
      isImageDeleted,
      description,
      endInDay,
      linkText,
      link,
      fee,
      isLinkOnly,
      consumeLimitPerDay: resetGameDays,
    };
    if (this.isReward()) {
      data.videoUrl = videoUrl;
      data.videoFiles = videoFiles;
      data.isVideoDeleted = isVideoDeleted;
    }
    return data;
  }

  render() {
    const {
      showValidationMsg,
      name,
      startAt,
      endAt,
      description,
      endInDay,
      resetGameDays,
      linkText,
      link,
      fee,
      isLinkOnly
    } = this.state;
    const {activityData, classes, isXS, isDrawerHidden, app} = this.props;

    const isReward = this.isReward();

    const showDescription = activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.DISCOUNT
      || activityData.type === constants.activity.types.VOUCHER
      || activityData.type === constants.activity.types.SMART_AD
      || activityData.type === constants.activity.types.EVENT;

    const showValidity = activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.DISCOUNT
      || activityData.type === constants.activity.types.VOUCHER;

    const showLink = activityData.type === constants.activity.types.SMART_AD;
    const showLoyaltyPoints = activityData.usageType === constants.activity.usageTypes.LOYALTY &&
      (activityData.type === constants.activity.types.OFFER || activityData.type === constants.activity.types.VOUCHER || activityData.type === constants.activity.types.DISCOUNT);
    const showResetGameDays = (activityData.usageType === constants.activity.usageTypes.MARKETING || activityData.usageType === constants.activity.usageTypes.LOYALTY)
      && (activityData.type === constants.activity.types.JACKPOT
        || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
        || activityData.type === constants.activity.types.GAME_BETTING_PIC
        || activityData.type === constants.activity.types.GAME_ROULETTE
        || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || activityData.type === constants.activity.types.GAME_FLIP_CARD
        || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
        || activityData.type === constants.activity.types.GAME_MATCH_PAIR
        || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_POKER
        || activityData.type === constants.activity.types.GAME_MATCH_THREE
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
        || activityData.type === constants.activity.types.GAME_BRAND_RACE
        || activityData.type === constants.activity.types.QUESTIONNAIRE
        || activityData.type === constants.activity.types.SURVEY
      );

    let startDateError = null;
    let endDateError = null;
    let newRewardLoyaltyPointsError = null;
    let endInDayErrorText = null;
    if (showValidationMsg) {
      if (!startAt) {
        startDateError = <FormattedMessage id='generic.validation.required'/>;
      } else if (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow)) {
        startDateError = <FormattedMessage id='activity.manage.startDateAfterCurrentDate'/>;
      }
      if (!endAt) {
        endDateError = <FormattedMessage id='generic.validation.required'/>;
      } else if (!DateTimeHelper.isDateAfter(endAt, startAt ? startAt : this.dateNow)) {
        endDateError = <FormattedMessage id='activity.manage.endDateAfterStartDate'/>;
      }
      newRewardLoyaltyPointsError = !fee || ValueHelper.getEnglishValue(fee) <= 0;
      if (!endInDay || ValueHelper.getEnglishValue(endInDay) < this.minOfferValidity) {
        endInDayErrorText = <FormattedMessage id='activity.validation.requiredValueOrMore' values={{value: this.minOfferValidity}} />;
      }
    }

    const showPreview = !isReward && !isXS && this.state.previewData;
    const previewWidth = isDrawerHidden ? 360 : 380;

    const viewSeparatorHorizontal = (
      isXS ?
      <React.Fragment>
       <FieldSpace multiplier={2}/>
      </React.Fragment>
      :
      <React.Fragment>
        <FieldSpace multiplier={1.5}/>
        <div style={{height: 1.5, width: '100%', backgroundColor: ColorSeparator}} />
        <FieldSpace multiplier={1.5}/>
      </React.Fragment>
    );

    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={classes.viewRowFullWidthNoCenter}>
          <div className={classes.flexColumnNoCenter} style={{flex: 2}}>
            <div className={isReward ? classes.formActivityWide : classes.formActivity}>
              <SectionHeaderView labelId={isReward ? 'activity.tabRewardDetailsHeader' : 'activity.tabDetailsHeader'} />

              <MediaPlaceholder labelId={isReward ? 'activity.imageObliqueVideo' : 'campaign.coverImage'} />
              <SingleFilePicker
                key={'SFP1'}
                required={false}
                size={'small'}
                filesLimit={1}
                acceptedFiles={isReward ? {...ACCEPTED_IMAGE_MIMES, ...ACCEPTED_VIDEO_MIMES} : ACCEPTED_IMAGE_MIMES}
                maxSizeMimes={{image: 20*1024*1024, video: 100*1024*1024}}
                maxDurationMimes={{video: this.maxVideoDuration}}
                maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
                aspectRatio={4/3}
                initialFiles={this.initialMediaFiles}
                onError={this.onErrorFiles}
                onChange={(files) => {
                  this.onChangeFiles(files, 'mediaUrl');
                }}
                onDelete={(file) => {
                  this.onDeleteFile(file, 'mediaUrl');
                }}
              />
              <FieldSpace />

              <TextField
                variant="filled"
                fullWidth
                required
                size="small"
                type="text"
                id="name"
                name="name"
                label={<FormattedMessage id={this.getFieldTitlePlaceholderId()}/>}
                InputProps={{disableUnderline: true}}
                inputProps={{maxLength: 200}}
                value={name}
                onChange={this.onChange}
                error={showValidationMsg && !name}
                helperText={showValidationMsg && !name && <FormattedMessage id='generic.validation.required' />}
              />
              <FieldSpace />

              {showDescription ?
                <div className={classes.viewColumnFullWidth}>
                  <TextField
                    multiline
                    rows={2}
                    rowsMax={6}
                    variant="filled"
                    fullWidth
                    size="small"
                    type="text"
                    id="description"
                    name="description"
                    label={<FormattedMessage id={this.getFieldDescriptionPlaceholderId()}/>}
                    InputProps={{disableUnderline: true}}
                    inputProps={{maxLength: 2000}}
                    value={description}
                    onChange={this.onChange}
                  />
                  <FieldSpace />
                </div>
                : null
              }

              <div style={{marginLeft: -16}}>
                <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
                  <div className={isXS ? classes.flexColumnNoCenter : classes.flexRowWrap}>
                    <div style={{flex: 1, minWidth: 200, marginLeft: 16}}>
                      <DateTimePicker
                        inputVariant="filled"
                        variant="inline"
                        size="small"
                        fullWidth
                        autoOk
                        required={!activityData.noEditStartAt}
                        disablePast
                        InputProps={{disableUnderline: true}}
                        format="DD/MM/YYYY hh:mm A"
                        disabled={activityData.noEditStartAt}
                        id="startAt"
                        name="startAt"
                        invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                        maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                        minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                        label={<FormattedMessage id='activity.manage.startDate'/>}
                        minDate={this.dateNow}
                        maxDate={this.dateMax}
                        value={startAt}
                        onChange={(date) => {
                          this.updateState({showValidationMsg: false, startAt: date})
                        }}
                        keyboardbuttonprops={{
                          'aria-label': 'change date',
                        }}
                        error={startDateError}
                        helperText={startDateError}
                      />
                      <FieldSpace />
                    </div>
                    {/*<div style={{flex: 1, minWidth: 200, marginLeft: 16}}>*/}
                    {/*  <DateTimePicker*/}
                    {/*    inputVariant="filled"*/}
                    {/*    variant="inline"*/}
                    {/*    size="small"*/}
                    {/*    fullWidth*/}
                    {/*    autoOk*/}
                    {/*    required*/}
                    {/*    disablePast*/}
                    {/*    InputProps={{disableUnderline: true}}*/}
                    {/*    format="DD/MM/YYYY hh:mm A"*/}
                    {/*    id="endAt"*/}
                    {/*    name="endAt"*/}
                    {/*    invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}*/}
                    {/*    maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
                    {/*    minDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
                    {/*    label={<FormattedMessage id='activity.manage.endDate'/>}*/}
                    {/*    minDate={startAt ? startAt : this.dateNow}*/}
                    {/*    value={endAt}*/}
                    {/*    onChange={(date) => {*/}
                    {/*      this.updateState({showValidationMsg: false, endAt: date})*/}
                    {/*    }}*/}
                    {/*    keyboardbuttonprops={{*/}
                    {/*      'aria-label': 'change date',*/}
                    {/*    }}*/}
                    {/*    error={endDateError}*/}
                    {/*    helperText={endDateError}*/}
                    {/*  />*/}
                    {/*  <Space horizontal={inputSpace}/>*/}
                    {/*</div>*/}
                  </div>
                </MuiPickersUtilsProvider>
              </div>

              {/*{showValidity ?*/}
              {/*  <div className={classes.viewColumnFullWidth}>*/}
              {/*    <TextField*/}
              {/*      required*/}
              {/*      variant="filled"*/}
              {/*      fullWidth*/}
              {/*      size="small"*/}
              {/*      type="number"*/}
              {/*      id="endInDay"*/}
              {/*      name="endInDay"*/}
              {/*      label={<FormattedMessage id={'activity.offerValidity'}/>}*/}
              {/*      value={endInDay}*/}
              {/*      InputProps={{disableUnderline: true}}*/}
              {/*      inputProps={{min: 1, max: 365}}*/}
              {/*      onChange={this.onChange}*/}
              {/*      onKeyDown={textFieldIntegerOnKeyDown}*/}
              {/*      error={showValidationMsg && endInDayErrorText != null}*/}
              {/*      helperText={showValidationMsg && endInDayErrorText != null ? endInDayErrorText : <FormattedMessage id={'activity.hintOfferValidity'} />}*/}
              {/*    />*/}
              {/*    <FieldSpace />*/}
              {/*  </div>*/}
              {/*  : null*/}
              {/*}*/}
            </div>
            <FieldSpace multiplier={-1}/>
          </div>
          {showPreview ?
            <div style={{width: 1.5, backgroundColor: ColorSeparator, marginLeft: FIELD_SPACE * 1.5, marginRight: FIELD_SPACE * 1.5}} />
            : null
          }
          {showPreview ?
            <div style={{flex: 1.3}}>
              {!isXS ? <div style={{flex: 1}}/> : null}
              <SectionHeaderView labelId={'activity.previewR'} subLabelId={'activity.previewPlayListSubtitle'} />
              <div>
                <div style={{width: previewWidth, height: 200, position: 'relative'}}>
                  <GetViewForItem disabled={true} key={''+ this.state.reload} isXS={isXS} item={this.state.previewData} isLTR={app.isLTR} classes={classes} />
                </div>
              </div>
              {!isXS ? <div style={{flex: 5}}/> : null}
            </div>
            : null
          }
        </div>

        {!isReward ?
          <React.Fragment>
            {viewSeparatorHorizontal}
            <div className={classes.viewColumnFullWidthNoCenter}>
              <SectionHeaderView labelId={'campaign.publicLinkTitle'} extraBottomSpace={true} />
              <RadioGroup name="isLinkOnly" value={isLinkOnly} onChange={this.onChange} className={isXS ? classes.viewColumnFullWidthNoCenter : classes.viewRowFullWidthNoCenter}>
                <FormControlLabel className={isLinkOnly === '0' ? classes.radioButtonLinkSelected : classes.radioButtonLink} style={{paddingLeft: !app.isLTR ? 12 : 0, paddingRight: app.isLTR ? 12 : 0}} value="0" control={<Radio color={'primary'}/>} label={
                  <div className={classes.formActivity}>
                    <div className={classes.linkBg}>
                      <ImageIcon src={require('src/images/ic_globe.png')} />
                    </div>
                    <TextView variant={'body2'} fontWeight={FONT_WEIGHT_MEDIUM} align={'left'} text={<FormattedMessage id={'activity.publicAccess'} />} />
                    <TextView variant={'caption'} align={'left'} color={ColorSubTitle}><FormattedMessage id={'activity.publicAccessHint'} /></TextView>
                  </div>
                } />
                <FieldSpace vertical={!isXS} multiplier={0.6}/>
                <FormControlLabel className={isLinkOnly === '1' ? classes.radioButtonLinkSelected : classes.radioButtonLink} style={{paddingLeft: !app.isLTR ? 12 : 0, paddingRight: app.isLTR ? 12 : 0}} value="1" control={<Radio color={'primary'}/>} label={
                  <div className={classes.formActivity}>
                    <div className={classes.linkBg}>
                      <ImageIcon src={require('src/images/ic_link_c.png')} />
                    </div>
                    <TextView variant={'body2'} fontWeight={FONT_WEIGHT_MEDIUM} align={'left'} text={<FormattedMessage id={'activity.linkOnlyAccess'} />} />
                    <TextView variant={'caption'} align={'left'} color={ColorSubTitle}><FormattedMessage id={'activity.linkOnlyAccessHint'} /></TextView>
                  </div>
                } />
              </RadioGroup>
            </div>
          </React.Fragment>
          : null
        }

        {showResetGameDays ?
          <React.Fragment>
            {viewSeparatorHorizontal}
            <SectionHeaderView labelId={'activity.manage.sectionResetDays'} subLabelId={'activity.manage.sectionHintAutoRestart'} extraBottomSpace={true} />
            <div className={classes.flexRowWrap} style={{marginBottom: -8}}>
              {AUTO_RESTART_DAYS.map((item, index) => {
                const isSelected = item.id === resetGameDays;
                return (
                  <Button
                    color={isSelected ? 'primary' : 'secondary'}
                    variant={"outlined"}
                    onClick={() => {
                      this.updateState({resetGameDays: item.id});
                    }}
                    style={{marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, marginBottom: 8}}
                    className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
                    startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
                    <FormattedMessage id={item.name} />
                  </Button>
                );
              })}
            </div>
            <FieldSpace/>
          </React.Fragment>
          : <FieldSpace/>
        }

        {/*{showLoyaltyPoints ?*/}
        {/*  <div className={classes.formActivity} style={{marginTop: 1.5 * FIELD_SPACE}}>*/}
        {/*    <TextField*/}
        {/*      required*/}
        {/*      variant="filled"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="fee"*/}
        {/*      name="fee"*/}
        {/*      label={<FormattedMessage id='activity.manage.loyaltyRewardFee'/>}*/}
        {/*      InputProps={{disableUnderline: true}}*/}
        {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*      value={fee}*/}
        {/*      onChange={this.onChange}*/}
        {/*      onKeyDown={textFieldIntegerOnKeyDown}*/}
        {/*      error={newRewardLoyaltyPointsError}*/}
        {/*      helperText={newRewardLoyaltyPointsError ? <FormattedMessage id='activity.requiredLoyaltyPointsToRedeem' /> : null}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showLink ?*/}
        {/*  <div className={classes.formActivity} style={{marginTop: 1.5 * FIELD_SPACE}}>*/}
        {/*    <TextField*/}
        {/*      variant="filled"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="url"*/}
        {/*      id="link"*/}
        {/*      name="link"*/}
        {/*      label={<FormattedMessage id='activity.manage.actionButtonLink'/>}*/}
        {/*      InputProps={{disableUnderline: true}}*/}
        {/*      inputProps={{maxLength: 1024}}*/}
        {/*      value={link}*/}
        {/*      onChange={this.onChange}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}

        {/*    <TextField*/}
        {/*      variant="filled"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="text"*/}
        {/*      id="linkText"*/}
        {/*      name="linkText"*/}
        {/*      label={<FormattedMessage id='activity.manage.actionButtonTitle'/>}*/}
        {/*      InputProps={{disableUnderline: true}}*/}
        {/*      inputProps={{maxLength: 12}}*/}
        {/*      value={linkText}*/}
        {/*      onChange={this.onChange}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {this.renderSnackBar()}
      </div>
    )
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFieldTitlePlaceholderId() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.VOUCHER
      || activityData.type === constants.activity.types.DISCOUNT) {
      return 'activity.rewardTitle';
    }
    if (activityData.type === constants.activity.types.EVENT) {
      return 'activity.eventTitle';
    }
    return 'activity.campaignTitle';
  }

  getFieldDescriptionPlaceholderId() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.VOUCHER
      || activityData.type === constants.activity.types.DISCOUNT) {
      return 'activity.rewardDetails';
    }
    if (activityData.type === constants.activity.types.EVENT) {
      return 'activity.eventDetails';
    }
    return 'activity.campaignDetails';
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onFormSectionToggle = (section) => {
    const {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    eSections[index].expand = !eSections[index].expand;
    this.setState({sections: eSections});
  }

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      mediaUrl,
    } = this.state;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      mediaUrl,
      mediaFiles,
    } = this.state;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles, [keyIsImageDeleted]: true});
  }

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'resetGameDays' || event.target.name === 'fee') {
      const maxValue = (event.target.name === 'resetGameDays' || event.target.name === 'endInDay') ? 365 : constants.activity.VALUE_DEFAULT_MAX;
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    } else if (event.target.name === 'name') {
      value = value.replace("\n", " ");
    } else if (event.target.name === 'link') {
      value = value.trim();
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChangeBusiness = (value) => {
    if (value.length > 1) {
      this.updateState({businessSearch: value, business: null, isBusinessLoading: true, showValidationMsg: false});
      this.fetchBusinesses(value);
    } else {
      this.updateState({businessSearch: value, business: null, showValidationMsg: false});
    }
  };

  onSelectBusiness = (value) => {
    this.updateState({
      business: value,
      showValidationMsg: false,
      isBusinessLoading: false,
    });
  };

  fetchBusinesses(value) {
    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout);
    }
    this.clearTimeout = setTimeout(() => {
      this.props.fetchBusinesses(value).then(() => {
        this.updateState({isBusinessLoading: false});
      });
    }, 200);
  }

}

ManageActivityBasicInfo.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  categories: PropTypes.array,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchBusinesses: PropTypes.func,
};

ManageActivityBasicInfo.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityBasicInfo))
);
